// Shared number formatters — extracted from PortfolioBuilder.jsx so refactored
// child components (OptimizerCard, IncomeTargetCard, SnapshotHistory) can reuse
// the exact same formatting without duplicating the logic.
export const fmt$ = (v) => `$${Number(v).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
export const fmt$2 = (v) => `$${Number(v).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const fmtPct = (v) => `${Number(v).toFixed(2)}%`;
